// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Loyalty from "../../modules/Loyalty/Loyalty.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Customer from "../../modules/Customer/Customer.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as ResourceList from "../../core/ResourceList.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as CustomerRoutes from "./CustomerRoutes.res.js";
import * as LabelTableCell from "../../modules/TableCell/LabelTableCell.res.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as ResourceListPage from "../../core/ResourceListPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CompanyLegalNumber from "../../modules/CompanyLegalNumber.res.js";
import * as ElectronicInvoicing from "../../modules/ElectronicInvoicing/ElectronicInvoicing.res.js";
import * as ListNavigationState from "../../core/ListNavigationState.res.js";
import * as CustomerArchiveModal from "../../modules/Customer/CustomerArchiveModal.res.js";
import * as RequestOpenStorageUrl from "../../core/RequestOpenStorageUrl.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

function CustomerListPage$CustomerListAvatar(props) {
  let loyaltyEnabled = props.loyaltyEnabled;
  let siret = props.siret;
  let subscribedToLoyaltyProgramAt = props.subscribedToLoyaltyProgramAt;
  let business = props.business;
  let loyaltyProgramMember = loyaltyEnabled && props.loyaltyProgramMember;
  let tooltipContent = JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Tooltip.Span.make, {
        text: Customer.Kind.toLabel(business ? "Business" : (
            loyaltyProgramMember ? "LoyaltyMember" : "Individual"
          )),
        bold: true,
        size: "xsmall"
      }),
      !business && loyaltyEnabled ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(Tooltip.Gap.make, {
              space: "xsmall"
            }),
            JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("customer_list_page.avatar_tooltip.loyalty_program_label") + I18n.t(":") + " ",
              tone: "faded"
            }),
            JsxRuntime.jsx(Tooltip.Span.make, {
              text: loyaltyProgramMember ? (
                  subscribedToLoyaltyProgramAt !== undefined ? I18n.t("customer_list_page.avatar_tooltip.loyalty_program_member_since_prefix") + " " + DateHelpers.formateToShortDate(subscribedToLoyaltyProgramAt) : I18n.t("customer_list_page.avatar_tooltip.loyalty_program_member")
                ) : I18n.t("customer_list_page.avatar_tooltip.loyalty_program_not_member"),
              italic: !loyaltyProgramMember
            })
          ]
        }) : null,
      business ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(Tooltip.Gap.make, {
              space: "xxsmall"
            }),
            JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("SIRET number") + I18n.t(":") + " ",
              tone: "faded"
            }),
            JsxRuntime.jsx(Tooltip.Span.make, {
              text: Stdlib_Option.getOr(siret, I18n.t("N/C")),
              italic: Stdlib_Option.isNone(siret)
            })
          ]
        }) : null
    ]
  });
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Customer.Avatar.make, {
      business: business,
      loyaltyProgramMember: loyaltyProgramMember
    }),
    placement: "top",
    content: tooltipContent,
    delay: 0
  });
}

let CustomerListAvatar = {
  make: CustomerListPage$CustomerListAvatar
};

let make = React.memo(props => {
  let notification = props.notification;
  if (notification === undefined) {
    return null;
  }
  let tmp;
  tmp = notification.TAG === "Ok" ? ({
      TAG: "Success",
      _0: notification._0
    }) : ({
      TAG: "Danger",
      _0: notification._0
    });
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Banner.make, {
      textStatus: tmp,
      onRequestClose: props.onRequestClose
    }),
    spaceX: "large",
    spaceTop: "medium"
  });
});

let CustomerListNotificationBanner = {
  make: make
};

let endpoint = Env.sheetUrl() + "/customers";

function encodeRequestBodyJson(shopIds, param) {
  return Json.encodeDict(Object.fromEntries([[
      "shopIds",
      Json.encodeArray(shopIds.map(Json.encodeString))
    ]]));
}

function make$1(shopIds) {
  return Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeRequestBodyJson(shopIds, undefined)
  }, undefined, undefined);
}

function mapError(param) {
  return "UnexpectedFailure";
}

function messageFromError(error) {
  return I18n.t("customer_list_page.export_request.unexpected_failure");
}

function useDownload(request, shopIds) {
  let captureEvent = SessionTracker.useCaptureEvent();
  let request$1 = () => {
    captureEvent("download_customer_export_file");
    return request(shopIds);
  };
  let match = RequestOpenStorageUrl.use(request$1, undefined, undefined);
  let result = AsyncResult.mapError(match[0], mapError);
  return [
    result,
    match[1]
  ];
}

function CustomerListPage$CustomerListExportRequest$Button(props) {
  let onRequestNotification = props.onRequestNotification;
  let __request = props.request;
  let __shopIds = props.shopIds;
  let shopIds = __shopIds !== undefined ? __shopIds : [];
  let request = __request !== undefined ? __request : make$1;
  let match = useDownload(request, shopIds);
  let requestAndDownload = match[1];
  let operationResult = match[0];
  React.useEffect(() => {
    if (typeof operationResult === "object" && operationResult.TAG === "Done") {
      let error = operationResult._0;
      if (error.TAG === "Ok") {
        onRequestNotification({
          TAG: "Ok",
          _0: I18n.t("The file has been downloaded successfully.")
        });
      } else {
        onRequestNotification({
          TAG: "Error",
          _0: I18n.t("customer_list_page.export_request.unexpected_failure")
        });
      }
    }
  }, [AsyncResult.isDone(operationResult)]);
  return JsxRuntime.jsx(Button.make, {
    label: I18n.t("Export"),
    disabled: shopIds.length === 0,
    pending: AsyncData.isBusy(operationResult),
    icon: "export",
    tooltipText: shopIds.length === 0 ? I18n.t("Please select a shop beforehand.") : undefined,
    onPress: () => requestAndDownload()
  });
}

let Button$1 = {
  make: CustomerListPage$CustomerListExportRequest$Button
};

let CustomerListExportRequest = {
  endpoint: endpoint,
  encodeRequestBodyJson: encodeRequestBodyJson,
  make: make$1,
  mapError: mapError,
  messageFromError: messageFromError,
  useDownload: useDownload,
  Button: Button$1
};

let Raw = {};

let query = Client.gql(["query CustomerListQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputCustomersQueryFilter, $orderBy: [InputCustomersQueryOrderBy!])  {\ncustomers(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy, orderBy: $orderBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nhasSubscribedToLoyaltyProgram  \nsubscribedToLoyaltyProgramAt  \nkind  \nsiret  \nintraCommunityVAT  \ninvoicingEndpointId  \ninvoicingEndpointIdSchemeCode  \ninvoicingEndpointIdSchemeType  \nfirstName  \nlastName  \ncompanyName  \nlocations  {\n__typename  \ncity  \npostalCode  \n}\n\ndateOfBirth  \nemail  \nmobileNumber  \nphoneNumber  \ncreatedAt  \narchivedAt  \nshop  {\n__typename  \nid  \nname  \n}\n\nloyalty  {\n__typename  \npoints  \n}\n\nunlockedVouchers  {\n__typename  \nreward  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.customers;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    customers: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.subscribedToLoyaltyProgramAt;
        let value$3 = value$1.kind;
        let tmp;
        switch (value$3) {
          case "BUSINESS" :
            tmp = "BUSINESS";
            break;
          case "CONSUMER" :
            tmp = "CONSUMER";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$4 = value$1.siret;
        let value$5 = value$1.intraCommunityVAT;
        let value$6 = value$1.invoicingEndpointId;
        let value$7 = value$1.invoicingEndpointIdSchemeCode;
        let value$8 = value$1.invoicingEndpointIdSchemeType;
        let tmp$1;
        if (value$8 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$8) {
            case "BE_BCE" :
              tmp$2 = "BE_BCE";
              break;
            case "BE_TVA" :
              tmp$2 = "BE_TVA";
              break;
            case "FR_SIREN" :
              tmp$2 = "FR_SIREN";
              break;
            case "FR_SIREN_SIRET" :
              tmp$2 = "FR_SIREN_SIRET";
              break;
            case "FR_SIREN_SIRET_CODEROUTAGE" :
              tmp$2 = "FR_SIREN_SIRET_CODEROUTAGE";
              break;
            case "FR_SIREN_SUFFIX" :
              tmp$2 = "FR_SIREN_SUFFIX";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$9 = value$1.firstName;
        let value$10 = value$1.lastName;
        let value$11 = value$1.companyName;
        let value$12 = value$1.locations;
        let value$13 = value$1.dateOfBirth;
        let value$14 = value$1.email;
        let value$15 = value$1.mobileNumber;
        let value$16 = value$1.phoneNumber;
        let value$17 = value$1.archivedAt;
        let value$18 = value$1.shop;
        let value$19 = value$1.loyalty;
        let value$20 = value$1.unlockedVouchers;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            hasSubscribedToLoyaltyProgram: value$1.hasSubscribedToLoyaltyProgram,
            subscribedToLoyaltyProgramAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
            kind: tmp,
            siret: !(value$4 == null) ? value$4 : undefined,
            intraCommunityVAT: !(value$5 == null) ? value$5 : undefined,
            invoicingEndpointId: !(value$6 == null) ? value$6 : undefined,
            invoicingEndpointIdSchemeCode: !(value$7 == null) ? value$7 : undefined,
            invoicingEndpointIdSchemeType: tmp$1,
            firstName: !(value$9 == null) ? value$9 : undefined,
            lastName: !(value$10 == null) ? value$10 : undefined,
            companyName: !(value$11 == null) ? value$11 : undefined,
            locations: value$12.map(value => {
              let value$1 = value.city;
              let value$2 = value.postalCode;
              return {
                __typename: value.__typename,
                city: !(value$1 == null) ? value$1 : undefined,
                postalCode: !(value$2 == null) ? value$2 : undefined
              };
            }),
            dateOfBirth: !(value$13 == null) ? Scalar.Datetime.parse(value$13) : undefined,
            email: !(value$14 == null) ? value$14 : undefined,
            mobileNumber: !(value$15 == null) ? value$15 : undefined,
            phoneNumber: !(value$16 == null) ? value$16 : undefined,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            archivedAt: !(value$17 == null) ? Scalar.Datetime.parse(value$17) : undefined,
            shop: {
              __typename: value$18.__typename,
              id: value$18.id,
              name: value$18.name
            },
            loyalty: {
              __typename: value$19.__typename,
              points: value$19.points
            },
            unlockedVouchers: value$20.map(value => {
              let value$1 = value.reward;
              return {
                __typename: value.__typename,
                reward: !(value$1 == null) ? ({
                    __typename: value$1.__typename,
                    id: value$1.id
                  }) : undefined
              };
            })
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.customers;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.unlockedVouchers;
    let unlockedVouchers = value$2.map(value => {
      let value$1 = value.reward;
      let reward;
      if (value$1 !== undefined) {
        let value$2 = value$1.id;
        let value$3 = value$1.__typename;
        reward = {
          __typename: value$3,
          id: value$2
        };
      } else {
        reward = null;
      }
      let value$4 = value.__typename;
      return {
        __typename: value$4,
        reward: reward
      };
    });
    let value$3 = value$1.loyalty;
    let value$4 = value$3.points;
    let value$5 = value$3.__typename;
    let loyalty = {
      __typename: value$5,
      points: value$4
    };
    let value$6 = value$1.shop;
    let value$7 = value$6.name;
    let value$8 = value$6.id;
    let value$9 = value$6.__typename;
    let shop = {
      __typename: value$9,
      id: value$8,
      name: value$7
    };
    let value$10 = value$1.archivedAt;
    let archivedAt = value$10 !== undefined ? Scalar.Datetime.serialize(value$10) : null;
    let value$11 = value$1.createdAt;
    let value$12 = Scalar.Datetime.serialize(value$11);
    let value$13 = value$1.phoneNumber;
    let phoneNumber = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.mobileNumber;
    let mobileNumber = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.email;
    let email = value$15 !== undefined ? value$15 : null;
    let value$16 = value$1.dateOfBirth;
    let dateOfBirth = value$16 !== undefined ? Scalar.Datetime.serialize(value$16) : null;
    let value$17 = value$1.locations;
    let locations = value$17.map(value => {
      let value$1 = value.postalCode;
      let postalCode = value$1 !== undefined ? value$1 : null;
      let value$2 = value.city;
      let city = value$2 !== undefined ? value$2 : null;
      let value$3 = value.__typename;
      return {
        __typename: value$3,
        city: city,
        postalCode: postalCode
      };
    });
    let value$18 = value$1.companyName;
    let companyName = value$18 !== undefined ? value$18 : null;
    let value$19 = value$1.lastName;
    let lastName = value$19 !== undefined ? value$19 : null;
    let value$20 = value$1.firstName;
    let firstName = value$20 !== undefined ? value$20 : null;
    let value$21 = value$1.invoicingEndpointIdSchemeType;
    let invoicingEndpointIdSchemeType = value$21 !== undefined ? (
        value$21 === "BE_TVA" ? "BE_TVA" : (
            value$21 === "FR_SIREN" ? "FR_SIREN" : (
                value$21 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : (
                    value$21 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : (
                        value$21 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE"
                      )
                  )
              )
          )
      ) : null;
    let value$22 = value$1.invoicingEndpointIdSchemeCode;
    let invoicingEndpointIdSchemeCode = value$22 !== undefined ? value$22 : null;
    let value$23 = value$1.invoicingEndpointId;
    let invoicingEndpointId = value$23 !== undefined ? value$23 : null;
    let value$24 = value$1.intraCommunityVAT;
    let intraCommunityVAT = value$24 !== undefined ? value$24 : null;
    let value$25 = value$1.siret;
    let siret = value$25 !== undefined ? value$25 : null;
    let value$26 = value$1.kind;
    let kind = value$26 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
    let value$27 = value$1.subscribedToLoyaltyProgramAt;
    let subscribedToLoyaltyProgramAt = value$27 !== undefined ? Scalar.Datetime.serialize(value$27) : null;
    let value$28 = value$1.hasSubscribedToLoyaltyProgram;
    let value$29 = value$1.id;
    let value$30 = value$1.__typename;
    let node = {
      __typename: value$30,
      id: value$29,
      hasSubscribedToLoyaltyProgram: value$28,
      subscribedToLoyaltyProgramAt: subscribedToLoyaltyProgramAt,
      kind: kind,
      siret: siret,
      intraCommunityVAT: intraCommunityVAT,
      invoicingEndpointId: invoicingEndpointId,
      invoicingEndpointIdSchemeCode: invoicingEndpointIdSchemeCode,
      invoicingEndpointIdSchemeType: invoicingEndpointIdSchemeType,
      firstName: firstName,
      lastName: lastName,
      companyName: companyName,
      locations: locations,
      dateOfBirth: dateOfBirth,
      email: email,
      mobileNumber: mobileNumber,
      phoneNumber: phoneNumber,
      createdAt: value$12,
      archivedAt: archivedAt,
      shop: shop,
      loyalty: loyalty,
      unlockedVouchers: unlockedVouchers
    };
    let value$31 = value.__typename;
    return {
      __typename: value$31,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let customers = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    customers: customers
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectInputCustomersQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  let a$2 = inp.createdAt;
  let a$3 = inp.customerId;
  let a$4 = inp.kind;
  let a$5 = inp.hasSubscribedToLoyaltyProgram;
  let a$6 = inp.loyaltyPoints;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    archived: a$1 !== undefined ? (
        a$1 === "ONLY" ? "ONLY" : (
            a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    createdAt: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    customerId: a$3 !== undefined ? serializeInputObjectInFilter(a$3) : undefined,
    kind: a$4 !== undefined ? serializeInputObjectInFilter(a$4) : undefined,
    hasSubscribedToLoyaltyProgram: a$5 !== undefined ? ({
        _equals: a$5._equals
      }) : undefined,
    loyaltyPoints: a$6 !== undefined ? serializeInputObjectNumberRangeFilter(a$6) : undefined
  };
}

function serializeInputObjectInputCustomersQueryOrderBy(inp) {
  let a = inp.createdAt;
  let a$1 = inp.name;
  let a$2 = inp.dateOfBirth;
  let a$3 = inp.loyaltyPoints;
  return {
    createdAt: a !== undefined ? (
        a === "DESC" ? "DESC" : "ASC"
      ) : undefined,
    name: a$1 !== undefined ? (
        a$1 === "DESC" ? "DESC" : "ASC"
      ) : undefined,
    dateOfBirth: a$2 !== undefined ? (
        a$2 === "DESC" ? "DESC" : "ASC"
      ) : undefined,
    loyaltyPoints: a$3 !== undefined ? (
        a$3 === "DESC" ? "DESC" : "ASC"
      ) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  let a$6 = inp.orderBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputCustomersQueryFilter(a$5) : undefined,
    orderBy: a$6 !== undefined ? a$6.map(serializeInputObjectInputCustomersQueryOrderBy) : undefined
  };
}

function makeVariables(search, before, after, first, last, filterBy, orderBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy,
    orderBy: orderBy
  };
}

function makeInputObjectInputCustomersQueryFilter(shopIds, archived, createdAt, customerId, kind, hasSubscribedToLoyaltyProgram, loyaltyPoints, param) {
  return {
    shopIds: shopIds,
    archived: archived,
    createdAt: createdAt,
    customerId: customerId,
    kind: kind,
    hasSubscribedToLoyaltyProgram: hasSubscribedToLoyaltyProgram,
    loyaltyPoints: loyaltyPoints
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}

function makeInputObjectInputCustomersQueryOrderBy(createdAt, name, dateOfBirth, loyaltyPoints, param) {
  return {
    createdAt: createdAt,
    name: name,
    dateOfBirth: dateOfBirth,
    loyaltyPoints: loyaltyPoints
  };
}

function makeDefaultVariables() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined,
    orderBy: undefined
  };
}

let CustomerListQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCustomersQueryFilter: serializeInputObjectInputCustomersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  serializeInputObjectInputCustomersQueryOrderBy: serializeInputObjectInputCustomersQueryOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputCustomersQueryFilter: makeInputObjectInputCustomersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeInputObjectInputCustomersQueryOrderBy: makeInputObjectInputCustomersQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let CustomerListQuery_refetchQueryDescription = include.refetchQueryDescription;

let CustomerListQuery_useLazy = include.useLazy;

let CustomerListQuery_useLazyWithVariables = include.useLazyWithVariables;

let CustomerListQuery = {
  CustomerListQuery_inner: CustomerListQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCustomersQueryFilter: serializeInputObjectInputCustomersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  serializeInputObjectInputCustomersQueryOrderBy: serializeInputObjectInputCustomersQueryOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputCustomersQueryFilter: makeInputObjectInputCustomersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeInputObjectInputCustomersQueryOrderBy: makeInputObjectInputCustomersQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: CustomerListQuery_refetchQueryDescription,
  use: use,
  useLazy: CustomerListQuery_useLazy,
  useLazyWithVariables: CustomerListQuery_useLazyWithVariables
};

function keyExtractor(param) {
  return param.id;
}

let CustomerListTableRow = {
  keyExtractor: keyExtractor
};

function tableRowsFromQueryResult(queryResult) {
  return queryResult.customers.edges.map(param => {
    let node = param.node;
    return {
      id: node.id,
      business: node.kind === "BUSINESS",
      siret: node.siret,
      intraCommunityVat: node.intraCommunityVAT,
      invoicingAddress: Stdlib_Option.map(ElectronicInvoicing.InvoicingEndpoint.make(node.invoicingEndpointIdSchemeType, node.invoicingEndpointIdSchemeCode, node.invoicingEndpointId), ElectronicInvoicing.InvoicingEndpoint.format),
      name: Stdlib_Option.getOr(Customer.makeName(node.firstName, node.lastName, node.companyName), Placeholder.Empty.text),
      shopId: node.shop.id,
      shopName: node.shop.name,
      cityName: Stdlib_Option.filter(Stdlib_Option.map(Stdlib_Option.flatMap(node.locations[0], param => param.city), prim => prim.trim()), city => {
        if (city !== "") {
          return city.length >= 3;
        } else {
          return false;
        }
      }),
      postalCode: Stdlib_Option.filter(Stdlib_Option.map(Stdlib_Option.flatMap(node.locations[0], param => param.postalCode), prim => prim.trim()), postalCode => postalCode !== ""),
      dateOfBirth: node.dateOfBirth,
      email: node.email,
      phoneNumber: Stdlib_Option.filter(Stdlib_Option.map(Stdlib_Option.map(Stdlib_Option.map(Stdlib_Option.orElse(node.mobileNumber, node.phoneNumber), phoneNumber => phoneNumber.replaceAll(".", "")), phoneNumber => phoneNumber.replaceAll(",", "")), prim => prim.trim()), phoneNumber => {
        if (phoneNumber !== "") {
          return phoneNumber.length >= 8;
        } else {
          return false;
        }
      }),
      loyaltyProgramMember: node.hasSubscribedToLoyaltyProgram,
      subscribedToLoyaltyProgramAt: node.subscribedToLoyaltyProgramAt,
      loyaltyPoints: node.loyalty.points,
      unlockedRewardsCount: node.unlockedVouchers.length,
      createdAt: node.createdAt,
      status: Customer.Status.fromArchivedAt(node.archivedAt),
      archivedAt: node.archivedAt
    };
  });
}

let dateRangeCodec = JsonCodec.object2(param => [
  param[0].getTime(),
  param[1].getTime()
], param => ({
  TAG: "Ok",
  _0: [
    new Date(param[0]),
    new Date(param[1])
  ]
}), JsonCodec.field("start", JsonCodec.float), JsonCodec.field("end", JsonCodec.float));

function jsonCodec(shops) {
  return JsonCodec.object4(param => [
    Stdlib_Option.map(param.shop, shop => shop.id),
    param.createdAt,
    Stdlib_Option.map(param.type_, Customer.Kind.toString),
    Stdlib_Option.map(param.status, Customer.Status.toString)
  ], param => {
    let shopId = param[0];
    return {
      TAG: "Ok",
      _0: {
        shop: shops.find(shop => shop.id === shopId),
        createdAt: param[1],
        type_: Stdlib_Option.flatMap(param[2], Customer.Kind.fromString),
        status: Stdlib_Option.flatMap(param[3], Customer.Status.fromString)
      }
    };
  }, JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("createdAt", dateRangeCodec)), JsonCodec.optional(JsonCodec.field("type", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("status", JsonCodec.string)));
}

let CustomerListFilters = {
  dateRangeCodec: dateRangeCodec,
  jsonCodec: jsonCodec
};

function toBadge(value) {
  let match;
  switch (value) {
    case "Individual" :
      match = [
        false,
        false
      ];
      break;
    case "LoyaltyMember" :
      match = [
        false,
        true
      ];
      break;
    case "Business" :
      match = [
        true,
        false
      ];
      break;
  }
  return JsxRuntime.jsx(Customer.Badge.make, {
    business: match[0],
    loyaltyProgramMember: match[1]
  });
}

function values(loyaltyEnabled) {
  if (loyaltyEnabled) {
    return Customer.Kind.values;
  } else {
    return Customer.Kind.values.filter(value => value !== "LoyaltyMember");
  }
}

let make$2 = React.memo(props => {
  let onChange = props.onChange;
  let loyaltyEnabled = props.loyaltyEnabled;
  let value = props.value;
  let defaultItem_1 = I18n.t("All");
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined
  };
  let items = values(loyaltyEnabled).map(value => ({
    TAG: "Option",
    key: Customer.Kind.toString(value),
    label: value === "Individual" && loyaltyEnabled ? I18n.t("customer_list_page.filters.select_type.individual_kind.label") : Customer.Kind.toLabel(value),
    value: value,
    endElement: JsxRuntime.jsx(Customer.Badge.make, {
      business: value === "Business",
      loyaltyProgramMember: value === "LoyaltyMember",
      size: "small"
    })
  }));
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Type"),
    preset: "filter",
    size: "compact",
    highlighted: Stdlib_Option.isSome(value),
    sections: [
      {
        items: [defaultItem]
      },
      {
        items: items,
        title: I18n.t("Type")
      }
    ],
    value: {
      TAG: "Single",
      _0: value
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return onChange(change._0);
      }
    }
  });
});

let CustomerListFilterTypeSelect = {
  toBadge: toBadge,
  values: values,
  make: make$2
};

let make$3 = React.memo(props => {
  let onChange = props.onChange;
  let value = props.value;
  let defaultItem_1 = I18n.t("All");
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined
  };
  let items = Customer.Status.values.map(value => ({
    TAG: "Option",
    key: Customer.Status.toString(value),
    label: Customer.Status.toLabel(value),
    value: value
  }));
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Status"),
    preset: "filter",
    size: "compact",
    highlighted: value !== "Active",
    renderValue: param => {
      let selectedItems = param.selectedItems;
      if (selectedItems.length === 1) {
        let match = selectedItems[0];
        if (match.TAG === "Option") {
          let value = match.value;
          if (value !== undefined) {
            return JsxRuntime.jsx(Inline.make, {
              children: JsxRuntime.jsx(Customer.Status.Badge.make, {
                value: value,
                size: "normal"
              }),
              grow: false
            });
          }
        }
      }
      return JsxRuntime.jsx("span", {
        children: I18n.t("All")
      });
    },
    renderItem: param => {
      let item = param.item;
      if (item.TAG !== "Option") {
        return null;
      }
      let value = item.value;
      if (value !== undefined) {
        return JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(Customer.Status.Badge.make, {
            value: value
          }),
          grow: false
        });
      } else {
        return JsxRuntime.jsx("span", {
          children: I18n.t("All")
        });
      }
    },
    sections: [
      {
        items: [defaultItem]
      },
      {
        items: items,
        title: I18n.t("Statuses")
      }
    ],
    value: {
      TAG: "Single",
      _0: value
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return onChange(change._0);
      }
    }
  });
});

let CustomerListFilterStatusSelect = {
  make: make$3
};

let make$4 = React.memo(props => {
  let routerOptions = props.routerOptions;
  let status = props.status;
  let id = props.id;
  let match = React.useState(() => false);
  let setArchiveModalOpened = match[1];
  let tmp;
  tmp = status === "Active" ? JsxRuntime.jsx(MenuActions.Item.make, {
      title: I18n.t("Archive"),
      tone: "danger",
      icon: "archive",
      onAction: () => setArchiveModalOpened(param => true)
    }) : JsxRuntime.jsx(MenuActions.Item.make, {
      title: I18n.t("Unarchive"),
      tone: "brand",
      icon: "unarchive",
      onAction: () => setArchiveModalOpened(param => true)
    });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Offset.make, {
        children: JsxRuntime.jsxs(MenuActions.make, {
          children: [
            JsxRuntime.jsxs(MenuActions.Section.make, {
              children: [
                JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("See customer"),
                  href: CustomerRoutes.showRoute(id),
                  routerOptions: routerOptions,
                  icon: "variant_see"
                }),
                JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Edit"),
                  href: CustomerRoutes.editRoute(id, undefined),
                  routerOptions: routerOptions,
                  icon: "edit"
                })
              ]
            }),
            JsxRuntime.jsx(MenuActions.Section.make, {
              children: tmp
            })
          ],
          trigger: {
            TAG: "Compact",
            icon: "more_v2",
            variant: "subtle",
            size: "small",
            bold: true
          }
        }),
        right: -10,
        width: 48,
        height: 32
      }),
      JsxRuntime.jsx(CustomerArchiveModal.make, {
        id: id,
        status: status,
        opened: match[0],
        onRequestClose: () => setArchiveModalOpened(param => false)
      })
    ]
  });
});

let CustomerListTableRowActions = {
  make: make$4
};

function toSortDescriptor(sort) {
  switch (sort.TAG) {
    case "CreatedAt" :
      return {
        column: "created-at",
        direction: sort._0
      };
    case "Name" :
      return {
        column: "name",
        direction: sort._0
      };
    case "DateOfBirth" :
      return {
        column: "birthday",
        direction: sort._0
      };
    case "LoyaltyPoints" :
      return {
        column: "loyalty",
        direction: sort._0
      };
  }
}

function fromSortDescriptor(sort) {
  switch (sort.column) {
    case "birthday" :
      return {
        TAG: "Ok",
        _0: {
          TAG: "DateOfBirth",
          _0: sort.direction
        }
      };
    case "created-at" :
      return {
        TAG: "Ok",
        _0: {
          TAG: "CreatedAt",
          _0: sort.direction
        }
      };
    case "loyalty" :
      return {
        TAG: "Ok",
        _0: {
          TAG: "LoyaltyPoints",
          _0: sort.direction
        }
      };
    case "name" :
      return {
        TAG: "Ok",
        _0: {
          TAG: "Name",
          _0: sort.direction
        }
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}

let jsonCodec$1 = JsonCodec.object2(sort => [
  toSortDescriptor(sort).column,
  toSortDescriptor(sort).direction
], param => {
  let direction = param[1] === "descending" ? "descending" : "ascending";
  let ok = fromSortDescriptor({
    column: param[0],
    direction: direction
  });
  if (ok.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: ok._0
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: "Invalid sort descriptor"
      }
    };
  }
}, JsonCodec.field("column", JsonCodec.string), JsonCodec.field("direction", JsonCodec.string));

let CustomerListSorting = {
  toSortDescriptor: toSortDescriptor,
  fromSortDescriptor: fromSortDescriptor,
  jsonCodec: jsonCodec$1
};

function queryVariablesFilterBy($staropt$star, param) {
  let status = param.status;
  let type_ = param.type_;
  let createdAt = param.createdAt;
  let shop = param.shop;
  let loyaltyEnabled = $staropt$star !== undefined ? $staropt$star : true;
  let type_$1;
  if (type_ !== undefined) {
    switch (type_) {
      case "LoyaltyMember" :
        type_$1 = loyaltyEnabled ? type_ : "Individual";
        break;
      case "Individual" :
      case "Business" :
        type_$1 = type_;
        break;
    }
  } else {
    type_$1 = type_;
  }
  let tmp;
  tmp = status !== undefined ? (
      status === "Active" ? "EXCLUDED" : "ONLY"
    ) : "INCLUDED";
  let tmp$1;
  if (type_$1 !== undefined) {
    switch (type_$1) {
      case "Individual" :
      case "LoyaltyMember" :
        tmp$1 = {
          _in: ["CONSUMER"]
        };
        break;
      case "Business" :
        tmp$1 = {
          _in: ["BUSINESS"]
        };
        break;
    }
  } else {
    tmp$1 = undefined;
  }
  let tmp$2;
  if (type_$1 !== undefined) {
    switch (type_$1) {
      case "Individual" :
        tmp$2 = loyaltyEnabled ? ({
            _equals: false
          }) : undefined;
        break;
      case "LoyaltyMember" :
        tmp$2 = {
          _equals: true
        };
        break;
      case "Business" :
        tmp$2 = undefined;
        break;
    }
  } else {
    tmp$2 = undefined;
  }
  return {
    shopIds: shop !== undefined ? ({
        _in: [shop.id]
      }) : undefined,
    archived: tmp,
    createdAt: createdAt !== undefined ? ({
        _after: undefined,
        _before: undefined,
        _between: [
          Scalar.Datetime.serialize(createdAt[0]),
          Scalar.Datetime.serialize(createdAt[1])
        ]
      }) : undefined,
    customerId: undefined,
    kind: tmp$1,
    hasSubscribedToLoyaltyProgram: tmp$2,
    loyaltyPoints: undefined
  };
}

function queryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "CreatedAt" :
      return {
        createdAt: toRawDirection(sort._0),
        name: undefined,
        dateOfBirth: undefined,
        loyaltyPoints: undefined
      };
    case "Name" :
      return {
        createdAt: undefined,
        name: toRawDirection(sort._0),
        dateOfBirth: undefined,
        loyaltyPoints: undefined
      };
    case "DateOfBirth" :
      return {
        createdAt: undefined,
        name: undefined,
        dateOfBirth: toRawDirection(sort._0),
        loyaltyPoints: undefined
      };
    case "LoyaltyPoints" :
      return {
        createdAt: undefined,
        name: undefined,
        dateOfBirth: undefined,
        loyaltyPoints: toRawDirection(sort._0)
      };
  }
}

function queryVariables($staropt$star, param) {
  let match = param.connectionArguments;
  let loyaltyEnabled = $staropt$star !== undefined ? $staropt$star : true;
  return {
    search: param.searchQuery,
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last,
    filterBy: queryVariablesFilterBy(loyaltyEnabled, param.filters),
    orderBy: [queryVariablesOrderBy(param.sorting)]
  };
}

let tableLoadingOperations = [query];

function useQueryAsyncResultFn(variables) {
  return ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, variables));
}

function CustomerListPage(props) {
  let __useQueryAsyncResult = props.useQueryAsyncResult;
  let useQueryAsyncResult = __useQueryAsyncResult !== undefined ? __useQueryAsyncResult : useQueryAsyncResultFn;
  let authScope = Auth.useScope();
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let match = React.useState(() => {});
  let setNotification = match[1];
  let filters_status = "Active";
  let filters = {
    shop: activeShop,
    createdAt: undefined,
    type_: undefined,
    status: filters_status
  };
  let initialState = ResourceList.initialState(50, filters, {
    TAG: "CreatedAt",
    _0: "descending"
  }, undefined, undefined);
  let filtersJsonCodec = jsonCodec(shops);
  let match$1 = ResourceList.use(initialState, filtersJsonCodec, jsonCodec$1, undefined, undefined);
  let dispatch = match$1[1];
  let state = match$1[0];
  let shop = state.filters.shop;
  let loyaltyEnabled = shop !== undefined ? Loyalty.isAddonActivated(shops, shop.id) : Loyalty.isAddonActivatedInAny(shops);
  let queryAsyncResult = useQueryAsyncResult(queryVariables(loyaltyEnabled, state));
  let listNavigationRouterOptions;
  let exit = 0;
  let edges;
  if (typeof queryAsyncResult !== "object") {
    listNavigationRouterOptions = undefined;
  } else if (queryAsyncResult.TAG === "Reloading") {
    let match$2 = queryAsyncResult._0;
    if (match$2.TAG === "Ok") {
      edges = match$2._0.customers.edges;
      exit = 1;
    } else {
      listNavigationRouterOptions = undefined;
    }
  } else {
    let match$3 = queryAsyncResult._0;
    if (match$3.TAG === "Ok") {
      edges = match$3._0.customers.edges;
      exit = 1;
    } else {
      listNavigationRouterOptions = undefined;
    }
  }
  if (exit === 1) {
    let items = edges.map(param => CustomerRoutes.showRoute(param.node.id));
    listNavigationRouterOptions = {
      state: ListNavigationState.encode({
        items: items
      })
    };
  }
  let organisationAccount;
  organisationAccount = authScope.TAG === "Organisation";
  let businessOnly = state.filters.type_ === "Business";
  let shopFilter = organisationAccount ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
      variation: "secondary",
      value: state.filters.shop,
      hideLabel: true,
      truncateItemLabel: true,
      onChange: shop => dispatch({
        TAG: "FiltersUpdated",
        _0: param => {
          let init = initialState.filters;
          return {
            shop: shop,
            createdAt: init.createdAt,
            type_: init.type_,
            status: init.status
          };
        }
      })
    }) : null;
  let match$4 = state.filters;
  let activeFiltersCount = [
    Stdlib_Option.isSome(match$4.createdAt),
    Stdlib_Option.isSome(match$4.type_),
    match$4.status !== "Active"
  ].filter(active => active).length;
  let handleFilterReset = activeFiltersCount > 0 ? () => dispatch({
      TAG: "FiltersUpdated",
      _0: param => {
        let init = initialState.filters;
        return {
          shop: state.filters.shop,
          createdAt: init.createdAt,
          type_: init.type_,
          status: init.status
        };
      }
    }) : undefined;
  let onTableSortChange = sortDescriptor => {
    let sort = fromSortDescriptor(sortDescriptor);
    if (sort.TAG === "Ok") {
      return dispatch({
        TAG: "SortingUpdated",
        _0: sort._0
      });
    }
  };
  let filters$1 = [
    JsxRuntime.jsx(SelectDateRangeFilter.make, {
      value: state.filters.createdAt,
      label: I18n.t("Creation date"),
      size: "compact",
      highlighted: Stdlib_Option.isSome(state.filters.createdAt),
      placeholder: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
      hidePresets: true,
      onChange: createdAt => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          createdAt: createdAt,
          type_: prev.type_,
          status: prev.status
        })
      }),
      triggerLabelDisplay: "showDateRange"
    }),
    JsxRuntime.jsx(CanarySeparator.make, {
      size: "medium",
      spacing: "xs"
    }),
    JsxRuntime.jsx(make$2, {
      value: state.filters.type_,
      loyaltyEnabled: loyaltyEnabled,
      onChange: type_ => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          createdAt: prev.createdAt,
          type_: type_,
          status: prev.status
        })
      })
    }),
    JsxRuntime.jsx(make$3, {
      value: state.filters.status,
      onChange: status => dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          createdAt: prev.createdAt,
          type_: prev.type_,
          status: status
        })
      })
    })
  ];
  let searchBar = JsxRuntime.jsx(ResourceListPage.ResourceListSearchBar.make, {
    placeholder: I18n.t("Search") + "...",
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let actions = JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(CustomerListPage$CustomerListExportRequest$Button, {
        shopIds: Stdlib_Option.map(state.filters.shop, shop => [shop.id]),
        onRequestNotification: result => setNotification(param => result)
      }),
      JsxRuntime.jsx(CanarySeparator.make, {}),
      JsxRuntime.jsxs(MenuActions.make, {
        children: [
          JsxRuntime.jsx(MenuActions.Item.make, {
            title: Customer.Kind.toLabel("Individual"),
            href: CustomerRoutes.newRoute(undefined, undefined),
            icon: "contact_v3"
          }, "individual"),
          JsxRuntime.jsx(MenuActions.Item.make, {
            title: Customer.Kind.toLabel("Business"),
            href: CustomerRoutes.newRoute(true, undefined),
            icon: "store"
          }, "business")
        ],
        trigger: {
          TAG: "Normal",
          label: I18n.t("New customer"),
          icon: "plus_small",
          variant: "solid",
          tone: "brand"
        }
      })
    ],
    space: "small"
  });
  let tableHeader = JsxRuntime.jsx(make, {
    notification: match[0],
    onRequestClose: () => setNotification(param => {})
  });
  let tableColumns = [
    {
      key: "avatar",
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 50
        },
        width: {
          NAME: "px",
          VAL: 50
        },
        margin: "none"
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(CustomerListPage$CustomerListAvatar, {
          business: match.business,
          loyaltyProgramMember: match.loyaltyProgramMember,
          subscribedToLoyaltyProgramAt: match.subscribedToLoyaltyProgramAt,
          siret: match.siret,
          loyaltyEnabled: Loyalty.isAddonActivated(shops, match.shopId)
        });
      }
    },
    {
      key: "name",
      name: I18n.t("Name"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 180
        },
        width: {
          NAME: "pct",
          VAL: 25
        },
        sticky: true
      },
      allowsSorting: true,
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: match.name,
          sublabel: organisationAccount ? match.shopName : undefined,
          href: CustomerRoutes.showRoute(match.id),
          routerOptions: listNavigationRouterOptions,
          inPrimaryColumn: true
        });
      }
    },
    {
      key: "business-identifiers",
      name: I18n.t("customer_list_page.table.business_identifiers_column.title"),
      layout: {
        hidden: !businessOnly,
        minWidth: {
          NAME: "px",
          VAL: 160
        },
        width: {
          NAME: "pct",
          VAL: 20
        }
      },
      render: param => {
        let match = param.data;
        let invoicingAddress = match.invoicingAddress;
        let identifier = Stdlib_Option.orElse(Stdlib_Option.map(match.siret, CompanyLegalNumber.French.format), match.intraCommunityVat);
        if (identifier === undefined && invoicingAddress === undefined) {
          return JsxRuntime.jsx(Placeholder.NC.make, {});
        }
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: Stdlib_Option.getOr(identifier, I18n.t("Not specified")),
          labelVariation: Stdlib_Option.isSome(identifier) ? undefined : "subdued",
          labelItalic: Stdlib_Option.isNone(identifier),
          sublabel: Stdlib_Option.getOr(invoicingAddress, I18n.t("Not specified")),
          sublabelVariation: Stdlib_Option.isSome(invoicingAddress) ? "normal" : "subdued",
          sublabelItalic: Stdlib_Option.isNone(invoicingAddress),
          showCopyButton: Stdlib_Option.isSome(identifier)
        });
      }
    },
    {
      key: "email",
      name: I18n.t("Email"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 140
        },
        width: {
          NAME: "fr",
          VAL: 2
        }
      },
      render: param => {
        let email = param.data.email;
        if (email !== undefined) {
          return JsxRuntime.jsx(LabelTableCell.make, {
            label: email,
            showCopyButton: true
          });
        } else {
          return JsxRuntime.jsx(Placeholder.NC.make, {});
        }
      }
    },
    {
      key: "phone",
      name: I18n.t("Phone"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 130
        }
      },
      render: param => {
        let phoneNumber = param.data.phoneNumber;
        if (phoneNumber === undefined) {
          return JsxRuntime.jsx(Placeholder.NC.make, {});
        }
        let label = I18n.phoneNumberFormat(phoneNumber);
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: label
        });
      }
    },
    {
      key: "city",
      name: I18n.t("City"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        }
      },
      render: param => {
        let match = param.data;
        let postalCode = match.postalCode;
        let cityName = match.cityName;
        if (cityName !== undefined) {
          if (postalCode !== undefined) {
            return JsxRuntime.jsx(LabelTableCell.make, {
              label: cityName,
              sublabel: postalCode
            });
          } else {
            return JsxRuntime.jsx(LabelTableCell.make, {
              label: cityName
            });
          }
        } else if (postalCode !== undefined) {
          return JsxRuntime.jsx(LabelTableCell.make, {
            label: postalCode
          });
        } else {
          return JsxRuntime.jsx(Placeholder.NC.make, {});
        }
      }
    },
    {
      key: "birthday",
      name: I18n.t("Birthday"),
      layout: {
        hidden: businessOnly,
        minWidth: {
          NAME: "px",
          VAL: 95
        }
      },
      allowsSorting: true,
      render: param => {
        let match = param.data;
        let dateOfBirth = match.dateOfBirth;
        if (dateOfBirth === undefined) {
          if (match.business) {
            return JsxRuntime.jsx(Placeholder.NA.make, {});
          } else {
            return JsxRuntime.jsx(Placeholder.NC.make, {});
          }
        }
        let birthdaySoon = Customer.isBirthdaySoon(dateOfBirth);
        let label = I18n.dateTimeFormat(undefined, undefined, undefined, undefined, "long", "numeric", undefined, undefined, undefined, dateOfBirth);
        let labelStartElement = birthdaySoon ? JsxRuntime.jsx(Icon.make, {
            name: "cake",
            fill: "#25243A",
            width: 14,
            height: 14,
            bold: true
          }) : null;
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: label,
          labelBold: birthdaySoon,
          labelStartElement: labelStartElement
        });
      }
    },
    {
      key: "loyalty",
      name: I18n.t("Loyalty"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 90
        }
      },
      allowsSorting: true,
      render: param => {
        let match = param.data;
        let unlockedRewardsCount = match.unlockedRewardsCount;
        let loyaltyPoints = match.loyaltyPoints;
        if (match.business) {
          return JsxRuntime.jsx(Placeholder.NA.make, {});
        }
        if (!match.loyaltyProgramMember) {
          return JsxRuntime.jsx(Placeholder.NA.make, {});
        }
        if (!Loyalty.isAddonActivated(shops, match.shopId)) {
          return JsxRuntime.jsx(Placeholder.NA.make, {});
        }
        let label = loyaltyPoints.toString() + (
          loyaltyPoints > 1 ? " points" : " point"
        );
        let sublabel = unlockedRewardsCount !== 0 ? (
            unlockedRewardsCount !== 1 ? I18n.template(I18n.t("{{count}} rewards"), {
                count: unlockedRewardsCount
              }, undefined) : I18n.t("1 reward")
          ) : undefined;
        let labelBold = loyaltyPoints > 0;
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: label,
          labelBold: labelBold,
          sublabel: sublabel
        });
      }
    },
    {
      key: "created-at",
      name: I18n.t("Creation date"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        },
        width: {
          NAME: "fr",
          VAL: 0
        }
      },
      allowsSorting: true,
      render: param => {
        let createdAt = param.data.createdAt;
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: DateHelpers.formateToShortDate(createdAt),
          sublabel: DateHelpers.formateToShortTime(undefined, createdAt)
        });
      }
    },
    {
      key: "status",
      name: I18n.t("Status"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 90
        },
        width: {
          NAME: "fr",
          VAL: 0
        }
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(Customer.Status.Badge.make, {
          value: match.status,
          archivedAt: match.archivedAt
        });
      }
    },
    {
      key: "actions",
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 48
        },
        width: {
          NAME: "px",
          VAL: 48
        },
        alignX: "flexEnd",
        sticky: true
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(make$4, {
          id: match.id,
          status: match.status,
          routerOptions: listNavigationRouterOptions
        });
      }
    }
  ];
  let tableColumns$1 = loyaltyEnabled ? tableColumns : tableColumns.filter(param => param.key !== "loyalty");
  let tableData = AsyncResult.mapError(AsyncResult.mapOk(queryAsyncResult, tableRowsFromQueryResult), param => {});
  let paginationTotalCount;
  if (typeof queryAsyncResult !== "object") {
    paginationTotalCount = 0;
  } else if (queryAsyncResult.TAG === "Reloading") {
    let match$5 = queryAsyncResult._0;
    paginationTotalCount = match$5.TAG === "Ok" ? match$5._0.customers.totalCount : 0;
  } else {
    let match$6 = queryAsyncResult._0;
    paginationTotalCount = match$6.TAG === "Ok" ? match$6._0.customers.totalCount : 0;
  }
  let paginationTotalPages = ResourceList.totalPages(paginationTotalCount, ResourceList.defaultEdgesPerPage);
  let paginationLoading = AsyncResult.isReloading(queryAsyncResult);
  let paginationLastDirection = state.currentPage > state.previousPage ? "Forward" : "Backward";
  let onRequestPaginate = React.useCallback(action => {
    let startCursor;
    let endCursor;
    let totalCount;
    if (typeof queryAsyncResult !== "object") {
      return;
    }
    if (queryAsyncResult.TAG === "Reloading") {
      let match = queryAsyncResult._0;
      if (match.TAG !== "Ok") {
        return;
      }
      let match$1 = match._0.customers;
      let match$2 = match$1.pageInfo;
      startCursor = match$2.startCursor;
      endCursor = match$2.endCursor;
      totalCount = match$1.totalCount;
    } else {
      let match$3 = queryAsyncResult._0;
      if (match$3.TAG !== "Ok") {
        return;
      }
      let match$4 = match$3._0.customers;
      let match$5 = match$4.pageInfo;
      startCursor = match$5.startCursor;
      endCursor = match$5.endCursor;
      totalCount = match$4.totalCount;
    }
    let totalPages = ResourceList.totalPages(totalCount, ResourceList.defaultEdgesPerPage);
    let nextPage = ResourceList.nextPage(state, action, totalPages);
    let cursors = [
      startCursor,
      endCursor
    ];
    if (nextPage !== undefined) {
      return dispatch({
        TAG: "Navigated",
        nextPage: nextPage,
        totalCount: totalCount,
        cursors: cursors
      });
    }
  }, [
    state.currentPage,
    queryAsyncResult
  ]);
  let tableLoadingInteraction = ResourceList.useLoadingInteraction(state, undefined);
  return JsxRuntime.jsx(ResourceListPage.make, {
    title: I18n.t("Customers"),
    shopFilter: shopFilter,
    filters: filters$1,
    activeFiltersCount: activeFiltersCount,
    actions: actions,
    searchBar: searchBar,
    tableHeader: tableHeader,
    tableData: tableData,
    tableColumns: tableColumns$1,
    tableKeyExtractor: keyExtractor,
    tableEmptyState: JsxRuntime.jsx(Placeholder.make, {
      status: "NoDataAvailable"
    }),
    paginationCurrentPage: state.currentPage,
    paginationTotalCount: paginationTotalCount,
    paginationTotalPages: paginationTotalPages,
    paginationLoading: paginationLoading,
    paginationLastDirection: paginationLastDirection,
    tableSortDescriptor: toSortDescriptor(state.sorting),
    tableLoadingOperations: tableLoadingOperations,
    tableLoadingInteraction: tableLoadingInteraction,
    onTableSortChange: onTableSortChange,
    onRequestPaginate: onRequestPaginate,
    onRequestResetFilters: handleFilterReset
  });
}

let make$5 = CustomerListPage;

export {
  CustomerListAvatar,
  CustomerListNotificationBanner,
  CustomerListExportRequest,
  CustomerListQuery,
  CustomerListTableRow,
  tableRowsFromQueryResult,
  CustomerListFilters,
  CustomerListFilterTypeSelect,
  CustomerListFilterStatusSelect,
  CustomerListTableRowActions,
  CustomerListSorting,
  queryVariablesFilterBy,
  queryVariablesOrderBy,
  queryVariables,
  tableLoadingOperations,
  useQueryAsyncResultFn,
  make$5 as make,
}
/* make Not a pure module */
